import React from "react";
import { Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles'
import PlayIcon from '@material-ui/icons/PlayCircleFilled'
import CheckIcon from '@material-ui/icons/CheckCircleRounded'
import CancelIcon from '@material-ui/icons/CancelSharp'
import PendingIcon from '@material-ui/icons/HourglassEmpty';
import RejectedIcon from '@material-ui/icons/ThumbDownOutlined';
import AcceptedIcon from '@material-ui/icons/ThumbUpOutlined';


const useStyles = makeStyles(theme => ({
    accepted: {
        color: "white",
        background: "DarkViolet",
        borderRadius: "25px",
        // width: "fit-content",
        // height: "fit-content"
    },
    inProgress: {
        color: "orange",
        background: "white",
        borderRadius: "25px",
        // width: "fit-content",
        // height: "fit-content"
    },
    completed: {
        color: "#00C853",
        background: "white",
        borderRadius: "25px",
        // width: ".75em",
        // height: ".75em"
    },
    cancelled: {
        color: "red",
        background: "white",
        borderRadius: "25px",
        // width: "fit-content",
        // height: "fit-content"
    },
    pending: {
        color: "yellow",
        background: "grey",
        borderRadius: "25px",
        // width: "fit-content",
        // height: "fit-content"
    },
    sync: {
        color: "red",
        background: "white",
        borderRadius: "25px"
    },
    accepted: {
        color: "green",
        background: "white",
        borderRadius: "25px"
    },
}))

export default function StatusIcon(props) {
    const classes = useStyles();
    const iconType = props.cancelStatus ? props.cancelStatus : props.moveStatus;

    switch (iconType) {
        case undefined:
        case null:
            return <></>;
        case 'pending acceptance':
            return (
                <Tooltip title={`Pending acceptance`} placement="top">
                    <PendingIcon className={classes.pending}></PendingIcon>
                </Tooltip>);
        case 'rejected':
            return (
                <Tooltip title={`Move rejected`} placement="top">
                    <RejectedIcon className={classes.sync}></RejectedIcon>
                </Tooltip>);
        case 'dispatched':
            return (
                <Tooltip title={`Move accepted`} placement="top">
                    <AcceptedIcon className={classes.accepted}></AcceptedIcon>
                </Tooltip>);
        case 'pending':
            return (
                <Tooltip title={`Cancel Status: ${props.cancelStatus}`} placement="top">
                    <CancelIcon className={classes.pending}></CancelIcon>
                </Tooltip>);
        case 'seen': case 'cancelled': case 'delivered': case 'returned':
            return (
                <Tooltip title={`Cancel Status: ${props.cancelStatus}`} placement="top">
                    <CancelIcon className={classes.cancelled}></CancelIcon>
                </Tooltip>);
        // case 'accepted': //this is not a used status- there is no way to get this status at the moment
        //     return (
        //         <Tooltip title={`Move Accepted`} placement="top">
        //             <ThumbIcon className={classes.accepted}></ThumbIcon>
        //         </Tooltip>
        //     );
        case 'delivery successful':
            return (
                <Tooltip title={`Move Completed`} placement="top">
                    <CheckIcon className={classes.completed}></CheckIcon>
                </Tooltip>);
        default:
            return (
                <Tooltip title={props.moveStatus} placement="top">
                    <PlayIcon className={classes.inProgress}></PlayIcon>
                </Tooltip>);
    }
}